import { createSlice } from '@reduxjs/toolkit';

// Actions
import { clearPreviousPackageDataAction } from '../actions/package';

// Types
import type { ExtraRoomsStateType } from '../extraRooms/types';

const initialState: ExtraRoomsStateType = {
  fetching: false,
  data: [],
  error: null,
  originalPackageId: null,
  isRequestCreated: false,
};

const extraRoomsSlice = createSlice({
  name: 'extra-rooms',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    getPackagesForRoomUpgrade: (state, _?: any) => ({
      ...state,
      isRequestCreated: true,
    }),
    getPackagesForRoomUpgradeSuccess: (
      state,
      {
        payload,
      }: {
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload: any[];
      },
    ) => {
      const originalPackageId = payload.length ? payload[0].package_id : null;

      return {
        ...state,
        data: payload,
        originalPackageId,
      };
    },
    getPackagesForRoomUpgradeFail: (
      state,
      {
        payload,
      }: {
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload: any;
      },
    ) => ({
      ...state,
      error: payload,
    }),
  },
  extraReducers: (builder) =>
    builder.addCase(clearPreviousPackageDataAction, () => initialState),
});

export const {
  getPackagesForRoomUpgrade,
  getPackagesForRoomUpgradeSuccess,
  getPackagesForRoomUpgradeFail,
} = extraRoomsSlice.actions;
export default extraRoomsSlice.reducer;
